module.exports = __webpack_public_path__ + "static/media/FAQ-Implement.8f48a586.svg";